// extracted by mini-css-extract-plugin
module.exports = {"base":"background_base__3w3Oi"};